/* global queryString */
/* eslint-disable import/no-extraneous-dependencies */
import $ from 'jquery'
import * as THREE from 'three'
import venues from 'bam-node-evp/src/Utilities/Venues'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import config from './config'
import { addStadiumById, removeFenceById } from './render/Stadiums'
import { addFieldComponents } from './render/FieldComponents'

import { toFence } from './render/FenceHelpers'

let camera
let controls

let fences = queryString?.fences?.split?.('|') || []
// I can't think of a smarter way of doing this right now.
if (fences.length === 1 && fences[0] === '') {
    fences = []
}

const venueIds = venues.venues.map((venue) => venue.value)

// Check to see if 3d Stadium exists in data
function findStadium(venueId) {
    return venueIds.includes(Number(venueId))
}
function updateCameraAndOrbits(container, renderer) {
    camera = new THREE.PerspectiveCamera(
        50,
        container.offsetWidth / container.offsetHeight,
        1,
        5000
    )

    // Default High Home
    const look = new THREE.Vector3(0, 180, 10)
    const startCamera = new THREE.Vector3(0, -380, 250, true)

    // Orbit
    camera.position.set(startCamera.x, startCamera.y, startCamera.z)
    camera.up.set(0, 0, 1).normalize()
    camera.zoom = 1
    camera.lookAt(look)
    camera.updateProjectionMatrix()

    controls = new OrbitControls(camera, renderer.domElement)

    controls.autoRotate = true
    controls.autoRotateSpeed = 1
    controls.zoomSpeed = 0.8
    controls.minDistance = 50
    controls.maxDistance = 1000
    controls.minPolarAngle = Math.PI / 5
    controls.maxPolarAngle = Math.PI / 2
    controls.enableDamping = true
    controls.dampingFactor = 0.5
    controls.target.set(0, 110, 50)
    controls.update()
}

// If stadium exists create 3d render
if (queryString.venueId && findStadium(queryString.venueId)) {
    $('#stadium-visual').show()

    // Scene
    const scene = new THREE.Scene()
    const light = new THREE.DirectionalLight(0xffffff)
    light.position.set(0, 0, 50)
    scene.add(light)

    const container = document.getElementById('viz')

    // Renderer
    const renderer = new THREE.WebGLRenderer({
        antialias: true,
        // preserveDrawingBuffer: true,
    })
    renderer.setClearColor(0xffffff, 1)

    const vizWidth = $(container).width()
    if (vizWidth > 0) {
        renderer.setSize(vizWidth, vizWidth * 0.25)
    } else {
        renderer.setSize($(container).width(), 500)
    }
    container.appendChild(renderer.domElement)

    // Camera
    updateCameraAndOrbits(container, renderer)

    if (fences.length) {
        unselectAllFences()
        for (let i = 0; i < fences.length; i++) {
            const id = Number(fences[i])
            $(`#fence_${id}`).prop('checked', true)
            removeFenceById(scene, id)
            const { fenceMesh } = toFence({
                venueId: id,
                color: config.defaultTrailColor,
                wireframe: true,
            })
            fenceMesh.name = `fence_${id}`
            scene.add(fenceMesh)
        }
    }

    if (queryString.venueId) {
        addStadiumById(scene, Number(queryString.venueId))
        const { fenceMesh, distance } = toFence({
            venueId: queryString.venueId,
        })
        fenceMesh.name = `default_fence_${queryString.venueId}`
        scene.add(fenceMesh)
        const fenceDistance = distance
        if (fenceDistance) {
            addFieldComponents(scene, {
                lf: fenceDistance.lf,
                rf: fenceDistance.rf,
            })
        }
    }

    const size = 50000
    const divisions = 380

    const gridHelper = new THREE.GridHelper(size, divisions, 0xf5f5f5, 0xf5f5f5)

    // Rotate to flip grid
    gridHelper.geometry.rotateX(Math.PI / 2)
    scene.add(gridHelper)

    // eslint-disable-next-line
    function animate() {
        requestAnimationFrame(animate)
        renderer.render(scene, camera)
        if (controls) {
            controls.update()
        }
    }
    animate()

    // eslint-disable-next-line
    function unselectAllFences() {
        $('input[type=checkbox]').each(function checkboxHandler() {
            if (this.id.indexOf('fence') > -1) {
                const id = Number(this.id.split('_')[1])
                removeFenceById(scene, id)
                $(`#fence_${id}`).prop('checked', false)
            }
        })
    }

    $('.fence').click(function fenceClickHandler() {
        const id = Number(this.id.split('_')[1])
        if (document.getElementById(this.id).checked) {
            fences.push(String(id))
            removeFenceById(scene, id)
            const { fenceMesh } = toFence({
                venueId: id,
                color: config.defaultTrailColor,
                wireframe: true,
            })
            fenceMesh.name = `fence_${id}`
            scene.add(fenceMesh)
        } else {
            removeFenceById(scene, id)
            fences = fences.filter((d) => d !== String(id))
            // removeLidarFenceById(scene,id);
        }

        populateUrl()
    })

    $('#btnFenceAll').click(() => {
        // reset
        fences = []
        $('input[type=checkbox]').each(function checkboxHandler2() {
            if (this.id.indexOf('fence') > -1) {
                const id = Number(this.id.split('_')[1])
                removeFenceById(scene, id)
                const { fenceMesh } = toFence({
                    venueId: id,
                    color: config.defaultTrailColor,
                    wireframe: true,
                })
                fenceMesh.name = `fence_${id}`
                scene.add(fenceMesh)

                $(`#fence_${id}`).prop('checked', true)
                fences.push(id)
            }
        })

        populateUrl()
    })

    $('#btnFenceNone').click(() => {
        unselectAllFences()
        fences = []
        populateUrl()
    })

    $('#fence-toggle').click(() => {
        $('#fences').toggle()
    })
}

$('#stop').click(() => {
    if (controls.autoRotate) {
        controls.autoRotate = false
        $('#stop').html('Start Spinning')
    } else {
        controls.autoRotate = true
        $('#stop').html('Stop Spinning')
    }
    controls.update()
})

function populateUrl() {
    const url = `/leaderboard/statcast-venue?venueId=${
        queryString.venueId
    }&fences=${fences.join('|')}`
    window.history.replaceState('', '', url)
    return url
}
